import { httpReauest } from "api/api";
import { CartContext } from "context/CartContext";
import {
  Heart,
  Home,
  Home2,
  Home3,
  SearchNormal1,
  SearchZoomIn,
  ShoppingCart,
} from "iconsax-react";
import React, { useContext, useEffect, useState } from "react";
import Flag from "react-flagkit";
import { useTranslation } from "react-i18next";
import { FaAlignJustify, FaAngleDown } from "react-icons/fa6";
import { Link, useLocation } from "react-router-dom";
import CartModal from "./common/CartModal";
import SearchModal from "./common/SearchModal";
import MegaMenu from "./MegaMenu";
import { FavoriteContext } from "context/FavoriteContext";
import FavoriteModal from "./common/FavoriteModal";

const Header = () => {
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [searchShow, setsearchShow] = useState(false);
  const [data, setData] = useState([]);
  const [mobile, setMobile] = useState(true);

  const location = useLocation();

  const { cartshow, setCartshow, cart } = useContext(CartContext);
  const { favoriteshow, setfavoriteshow, favorite } =
    useContext(FavoriteContext);

  const [t, i18n] = useTranslation("global");
  const handleChangeLanguge = (e) => {
    i18n.changeLanguage(e);
  };

  useEffect(() => {
    if (i18n.language == "fa" || i18n.language == "ar") {
      document.documentElement.dir = "rtl";
    } else {
      document.documentElement.dir = "ltr";
    }
  }, [i18n.language]);

  useEffect(() => {
    // getIp();
    if (window.innerWidth > 1024) {
      setMobile(false);
    }
    getData();
  }, []);

  async function getData() {
    const res = await httpReauest("GET", "/category", {}, {});
    // const res2 = await httpReauest("GET", "/category/sub", {}, {});
    setData(res.data.data);
  }

  return (
    <div dir="ltr" class=" nav-bar bg-transparent">
      <span
        className={`bg-[#f5f5f7] shadow h-[120%] fixed w-full overflow-hidden lg:w-[300px] z-30 duration-300 ${
          cartshow >= 1 ? "right-[0%]" : "right-[-100%]"
        }`}
      >
        <CartModal setModal={setCartshow} />
      </span>
      <span
        className={`bg-[#f5f5f7] shadow h-[120%] fixed w-full overflow-hidden lg:w-[300px] z-30 duration-300 ${
          favoriteshow >= 1 ? "right-[0%]" : "right-[-100%]"
        }`}
      >
        <FavoriteModal setModal={setfavoriteshow} />
      </span>
      <span
        className={`bg-[#f5f5f7] shadow h-[120%] fixed w-full overflow-hidden lg:w-[100%] z-30 duration-300 ${
          searchShow >= 1 ? "right-[0%]" : "right-[-100%]"
        }`}
      >
        <SearchModal setModal={setsearchShow} />
      </span>
      <div className="bg-[#3d3c38] network_bg">
        <nav class="navbar navbar-expand-lg container-xxl navbar-light py-1 2xl:px-4 z-10">
          <Link
            className="flex justify-center lg:items-center lg:w-fit w-full  sm:w-[140px]"
            to="/"
          >
            <img
              style={{ filter: "brightness(0) invert(1)" }}
              class="img-fluid w-[180px] sm:w-[140px] 2xl:w-[180px]  object-contain "
              src="/logo.png"
              alt="Icon"
            />
            <Home
              size={22}
              className="hover:text-red-500 text-[#fff] hidden lg:inline "
            />
          </Link>
          <span
            onClick={() => (show2 ? setShow2(false) : setShow2(true))}
            className="flex cursor-pointer   text-[12px] xl:text-[14px] relative mx-[0.5rem] xl:mx-[1rem]"
          >
            <span
              className="flex justify-center items-center gap-2 text-white "
              style={{ whiteSpace: "nowrap" }}
            >
              {i18n.language == "en" && <Flag country="US" />}
              {/* {i18n.language == "ru" && <Flag country="RU" />} */}
              {i18n.language == "ar" && <Flag country="AE" />}
              {/* {i18n.language == "fa" && <Flag country="IR" />} */}
              {i18n.language == "en" && "English - EN"}
              {/* {i18n.language == "ru" && "RU - Russian"} */}
              {i18n.language == "ar" && "AR - العربیة"}
              {/* {i18n.language == "fa" && "FA - فارسی "} */}
              <FaAngleDown className="" size={15} />
            </span>

            {show2 && (
              <span className={`drop_down h-fit text-[14px]`}>
                <span
                  onClick={() => handleChangeLanguge("en")}
                  className=" cursor-pointer flex items-center gap-2 w-full  py-2 px-3 whitespace-nowrap"
                >
                  <Flag country="US" />
                  <span> EN - English </span>
                </span>
                {/* <span
                  onClick={() => handleChangeLanguge("fa")}
                  className=" cursor-pointer flex items-center gap-2 w-full py-2 px-3 whitespace-nowrap "
                >
                  <Flag country="IR" />
                  <span> FA - فارسی </span>
                </span> */}
                <span
                  onClick={() => handleChangeLanguge("ar")}
                  className=" cursor-pointer flex items-center gap-2 w-full py-2 px-3 whitespace-nowrap "
                >
                  <Flag country="AE" />
                  <span> AR - العربیة </span>
                </span>
                {/* <span
                  onClick={() => handleChangeLanguge("ru")}
                  className=" cursor-pointer flex items-center gap-2 w-full py-2 px-3 whitespace-nowrap "
                >
                  <Flag country="RU" />
                  <span> RU - Russian</span>
                </span> */}
              </span>
            )}
          </span>
          <button
            type="button"
            class="navbar-toggler"
            onClick={() => setShow(!show)}
            style={{ borderColor: "#ffffff50" }}
          >
            <FaAlignJustify color="#fff" />
          </button>
          <div
            class={`${
              !show ? "max-h-0 " : "max-h-96"
            } lg:max-h-96 duration-500 navbar-collapse overflow-hidden lg:overflow-visible`}
            id="navbarCollapse"
          >
            <div class="navbar-nav flex-col  flex ltr:items-start justify-center w-full rtl:items-end ml-auto rtl:lg:flex-row-reverse ltr:lg:flex-row">
              {data?.slice(0, mobile ? 20 : 5)?.map((cat) => (
                <div className="relative group" key={cat?.url}>
                  <Link
                    to={`/category/${cat?.url}`}
                    className={`nav-item nav-link ${
                      location.pathname === `/category/${cat?.url}`
                        ? "active"
                        : ""
                    }`}
                  >
                    {cat?.[`name_${i18n.language}`] || cat?.name}
                  </Link>

                  {/* Dropdown زیرمجموعه‌ها */}
                  {cat?.subCategories?.length > 0 && (
                    <div className="duration-200 hidden absolute left-1/2 top-full bg-[#ffff] shadow text-[#000] text-[16px] text-center font-bold w-[180px] -translate-x-1/2 overflow-hidden lg:hidden lg:group-hover:block z-50">
                      {cat.subCategories.map((sub) => (
                        <Link
                          key={sub._id}
                          to={`/category/${cat?.url}/${sub?.url}`}
                          className="block px-4 py-2 hover:bg-gray-100 text-sm whitespace-nowrap"
                        >
                          {sub?.[`name_${i18n.language}`] || sub?.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
              <MegaMenu data={data} />
            </div>
            <span class="navbar-brand lg:flex items-center justify-end text-center hidden lg:gap-2 xl:gap-3 relative overflow-visible">
              <SearchNormal1
                color="#fff"
                className="cursor-pointer"
                onClick={() => setsearchShow(!cartshow)}
              />
              <span
                onClick={() => setCartshow(!cartshow)}
                className="relative cursor-pointer"
              >
                {cart.length ? (
                  <span className="absolute left-2/4 bottom-1/3 w-[23px] h-[23px] flex justify-center items-center  bg-red-500 text-white rounded-full text-[12px] z-10">
                    {cart.length}
                  </span>
                ) : null}
                <ShoppingCart color="#fff" />
              </span>
              <span
                onClick={() => setfavoriteshow(!favoriteshow)}
                className="relative cursor-pointer"
              >
                {favorite.length ? (
                  <span className="absolute left-2/4 bottom-1/3 w-[23px] h-[23px] flex justify-center items-center  bg-red-500 text-white rounded-full text-[12px] z-10">
                    {favorite.length}
                  </span>
                ) : null}
                <Heart color="#fff" />
              </span>
              <Link
                to="/sign"
                className="bg-red-500 px-3 py-2 rounded-full text-white text-[14px]"
              >
                {t("sign-login")}
              </Link>
            </span>
          </div>
        </nav>
      </div>
      <div className="fixed bottom-0 left-0 w-full flex justify-between bg-[#3d3c38] px-4 py-3 lg:hidden text-white">
        <SearchNormal1
          className="cursor-pointer"
          onClick={() => setsearchShow(!cartshow)}
        />
        <Link to={"/"}>
          <Home />
        </Link>
        <span
          onClick={() => setCartshow(!cartshow)}
          className="relative cursor-pointer"
        >
          {cart.length ? (
            <span className="absolute left-2/4 bottom-1/3 w-[23px] h-[23px] flex justify-center items-center  bg-red-500 text-white rounded-full text-[12px] z-10">
              {cart.length}
            </span>
          ) : null}
          <ShoppingCart />
        </span>
        <span
          onClick={() => setfavoriteshow(!favoriteshow)}
          className="relative cursor-pointer"
        >
          {favorite.length ? (
            <span className="absolute left-2/4 bottom-1/3 w-[23px] h-[23px] flex justify-center items-center  bg-red-500 text-white rounded-full text-[12px] z-10">
              {favorite.length}
            </span>
          ) : null}
          <Heart />
        </span>
      </div>
    </div>
  );
};

export default Header;
